import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { FontSizeProvider } from './contexts/FontSizeContext';
import { SpacingProvider } from './contexts/SpacingContext';
import { ToastProvider } from './contexts/ToastContext';
import { ToastContainer } from './components/ui/Toast';
import App from './App';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <FontSizeProvider>
        <SpacingProvider>
          <ToastProvider>
            <BrowserRouter>
              <App />
              <ToastContainer />
            </BrowserRouter>
          </ToastProvider>
        </SpacingProvider>
      </FontSizeProvider>
    </ThemeProvider>
  </React.StrictMode>
);
